import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    login (credentials) {
        return Api().post('login', credentials)
    },
    gmwlogin (credentials) {
        return GmwApi().post('login', credentials)
    },
}